interface SectionHeaderProps {
  title: string;
  className?: string;
}

export function SectionHeader({ title, className = '' }: SectionHeaderProps) {
  return (
    <div className={`bg-primary bg-opacity-10 rounded px-3 py-2 ${className}`}>
      <h6 className="fw-semibold text-primary m-0">{title}</h6>
    </div>
  );
}

export default SectionHeader;